import React, { useEffect, useState } from 'react';
import { getPaymentIframe } from '../../services/Filmmakers';

const PayoutHistory = () => {
  const [iFrameUrl, setIFreamUrl] = useState(null);
  useEffect(() => {
    getPaymentIframe('paymentHistory')
      .then((res) => {
        setIFreamUrl(res.data);
      })
      .catch(() => {
        // skip
      });
  }, []);

  return (
    <>
      <iframe
        height="800"
        width="1100"
        title="Payment history"
        src={iFrameUrl}
        frameBorder="0"
        style={{ border: '0' }}
        allowFullScreen
      />
    </>
  );
};

export default PayoutHistory;
